import React from "react";
import { S3_MENU_THUMBNAIL_FOLDER } from "../../store/constants";
import "./chef-cards.css";
import MenuCategoryStory from "./MenuCategoryStory";

const MenuCategory = (props) => {
  const menuCategory = props.items;
  return (
    <div>
      <div className="cuisine-slider-item">
        <MenuCategoryStory
          key={menuCategory._id}
          img={menuCategory.img ? S3_MENU_THUMBNAIL_FOLDER + menuCategory.img : ""}
          alt={menuCategory.alt}
          caption={menuCategory.name}
          ringClass={menuCategory.ringClass}
          dishes={menuCategory.dishes}
          categories={props.categories}
          id={props.id}
        />
      </div>
    </div>
  );
};

export default MenuCategory;
